import { useState } from "react";

//WORK IN PROGRESS
export const useServerSidePaging = () => {

    const [currentPage, setCurrentPage] = useState(1);


    return {
        currentPage, 
        setCurrentPage
    };
};
